import { useState,useEffect, useMemo } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitleDefault from '../default/DialogTitleDefault';
import { Box, Divider, Grid, TextField, Typography } from '@mui/material';
import { ButtonBasic, DateSingle, SelectEstadoReprogramar, SelectResultadoVisita } from '../../components';
import FechaFunction from '../../function/FechaFunction';
import ContadorVisitasTkService from '../../services/contadorVisitas-ticket.service';

const ModalAddVisitaServicio = ({
    show,
    hideModal,
    item,
    ticketId,
    servicioId,
    onGuardar2
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [obsEstado, setObsEstado] = useState('');
    const handleClose = () => hideModal();
    const [formAll, setFormAll] = useState({
        estadoVisita_cvt: {
            texto: null,
            textoErr: 'El estado es requerido',
            estadoErr: false,
            tipo: 'string'
        },
        fechaVisita_cvt: {
            texto: null,
            textoErr: 'El estado es requerido',
            estadoErr: false,
            tipo: 'string'
        },
    });
    const onChangeForm = (value,input) =>{
        let formOld = formAll;
        if(!formOld[input]){
            formOld[input] = {
                texto: value,
                textoErr: `El ${input} es requerido`,
                estadoErr: false,
                tipo: 'string'
            }
        }else{
            formOld[input].texto = value
        }
        if((!value || value === '') && input !== 'telefono_c'){
            formOld[input].estadoErr = true
        }else{
            formOld[input].estadoErr = false;
        }
        setFormAll({...formOld})
    }
    const onChangeFormSetError = (input,clear) =>{
        let formOld = formAll;
        formOld[input].estadoErr = !clear ? true : false
        setFormAll({...formOld})
    }
    const onSubmit = async() => {
        const form = {
            ticketId_cvt: ticketId,
            servicioId_cvt: servicioId,
            obs_cvt: obsEstado
        };
        let isOk = false;
        setIsLoading(true);
        const inputRequired = ['estadoVisita_cvt','fechaVisita_cvt']
        const propertyNames = Object.keys(formAll);
        await Promise.resolve(
        propertyNames.forEach((name)=>{
        if(formAll[name]?.texto && formAll[name]?.texto !== '' && !formAll[name]?.estadoErr){
            form[name] = formAll[name].texto
        }else{
            if(inputRequired.includes(name)){
                isOk = true;
                onChangeFormSetError(name)
            }
        }
        }))
        if(!isOk){
            if(form.estadoVisita_cvt === 'POSITIVA'){
                form.obs_cvt = null;
            }
            if(item?.id_cvt > 0) {
                form.id_cvt = item.id_cvt;
                await ContadorVisitasTkService.update(form)
                    .then(() => {
                        if(onGuardar2){
                            onGuardar2();
                        }
                        hideModal();
                    })
                    .finally(() => {
                        setIsLoading(false);
                    });
            }else{
                await ContadorVisitasTkService.register(form)
                    .then(() => {
                        if(onGuardar2){
                            onGuardar2();
                        }
                        hideModal();
                    })
                    .finally(() => {
                        setIsLoading(false);
                    });
            }
        }else{
            setIsLoading(false)
        }
    }

    useEffect(() => {
        if(item){
            setTimeout(() => {
                onChangeForm(item?.estadoVisita_cvt,'estadoVisita_cvt');
                onChangeForm(item?.fechaVisita_cvt,'fechaVisita_cvt');
                setObsEstado(item?.obs_cvt || '')
            }, 100);
        }else{
            const newDate = FechaFunction.addDaysDate(new Date(),0)
            setTimeout(() => {
                onChangeForm(null,'estadoVisita_cvt');
                onChangeForm(newDate,'fechaVisita_cvt');
            }, 100);
        }
    }, [item])

    const styleInput = useMemo(() => ({
        '& .MuiInputLabel-root':{
            color: 'gray',
            fontSize: 14,
            marginTop: -0.4
        },
        '& fieldset': {
            borderRadius: 2,
            height: 50,
            border: 1,
            borderColor: 'gray',
        },
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
                border:1,
                color: '#000',
                height: 50,
            },
            '&:hover':{
                border: 0.1,
                borderRadius: 2,
                borderColor: 'gray',
                height: 45,
            },
            '&.Mui-focused': {
                '&:hover':{
                    border: 0,
                    borderRadius: 2,
                    height: 45,
                }
            },
            color: 'gray',
            height: 45,
        }
    }), []);
    return(
        <Dialog open={show} disableEscapeKeyDown maxWidth='xs' fullWidth sx={{backdropFilter: 'blur(0.4px);'}}>
            <Box sx={{background: '#fff'}}>
                <DialogTitleDefault id="add-canal-priv" onClose={handleClose}>
                    <Typography sx={{flex:1,textAlign: 'center', color: '#000',fontWeight: 'bold'}} variant='h5'>
                        {item?.id_cvt > 0 ? 'Editar Visita' : 'Registrar Visita'}
                    </Typography>
                </DialogTitleDefault>
                <Divider sx={{background: 'gray'}} />
                <DialogContent sx={{minHeight: '40vh'}}>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Typography sx={{color: '#000'}}>Fecha de Visita</Typography>
                            <DateSingle
                                isFullWidth
                                maxDate={new Date()}
                                value={formAll.fechaVisita_cvt.texto}
                                onChange={(date) => onChangeForm(date,'fechaVisita_cvt')}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={{color: '#000'}}>Resultado:</Typography>
                            <SelectResultadoVisita
                                value={formAll.estadoVisita_cvt.texto}
                                onChange={(e)=>onChangeForm(e?.value, 'estadoVisita_cvt')}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={{color: '#000'}}>Ticket:</Typography>
                            <TextField
                                fullWidth
                                autoComplete='off'
                                sx={styleInput}
                                value={ticketId || '-'}
                                onChange={(e)=>console.log(e)}
                                inputProps={{ readOnly: true }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={{color: '#000'}}>Servicio:</Typography>
                            <TextField
                                fullWidth
                                autoComplete='off'
                                sx={styleInput}
                                value={servicioId || '-'}
                                onChange={(e)=>console.log(e)}
                                inputProps={{ readOnly: true }}
                            />
                        </Grid>
                        {formAll.estadoVisita_cvt.texto === 'NEGATIVA' && (
                            <Grid item xs={12}>
                                <Typography sx={{color: '#000'}}>Observación:</Typography>
                                <SelectEstadoReprogramar
                                    value={obsEstado}
                                    onChange={(e)=>setObsEstado(e?.value)}
                                />
                            </Grid>
                        )}
                    </Grid>
                </DialogContent>
                <Divider sx={{background: 'gray'}} />
                <DialogActions sx={{display:'flex', justifyContent:'center'}}>
                    <ButtonBasic
                        textButton='Cancelar'
                        variant='wk'
                        color='cancel'
                        onClick={()=>handleClose()}
                        isLoading={isLoading}
                    />
                    <ButtonBasic
                        textButton='Guardar'
                        onClick={()=>onSubmit()}
                        isLoading={isLoading}
                        variant='wk'
                        color='nextStep'
                    />
                </DialogActions>
            </Box>
        </Dialog>
    )
}

export default ModalAddVisitaServicio